export default "__VITE_ASSET__63adf49a__"